module["exports"] = [
  "Việt Nam"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/vi/address/default_country.js
// module id = 1643
// module chunks = 1